// Auto-updated by gfs-consolidated.ipynb / forecast_io.py

export const gfsDates_sst = [
  '2026-08-27',
  '2026-08-28',
  '2026-08-29',
  '2026-08-30',
  '2026-08-31',
  '2026-09-01',
  '2026-09-02',
  '2026-09-03',
  '2026-09-04',
  '2026-09-05',
  '2026-09-06',
  '2026-09-07',
  '2026-09-08',
  '2026-09-09',
  '2026-09-10',
  '2026-09-11',
  '2026-09-12'
];

export const gfsDates_pressure = [
  '2026-08-25',
  '2026-08-26',
  '2026-08-27',
  '2026-08-28',
  '2026-08-29',
  '2026-08-30',
  '2026-08-31',
  '2026-09-01',
  '2026-09-02',
  '2026-09-03',
  '2026-09-04',
  '2026-09-05',
  '2026-09-06',
  '2026-09-07',
  '2026-09-08',
  '2026-09-09',
  '2026-09-10'
];

export const gfsDates_wind = [
  '2026-08-25',
  '2026-08-26',
  '2026-08-27',
  '2026-08-28',
  '2026-08-29',
  '2026-08-30',
  '2026-08-31',
  '2026-09-01',
  '2026-09-02',
  '2026-09-03',
  '2026-09-04',
  '2026-09-05',
  '2026-09-06',
  '2026-09-07',
  '2026-09-08',
  '2026-09-09',
  '2026-09-10'
];

export const gfsDates_airtmp = [
  '2026-08-25',
  '2026-08-26',
  '2026-08-27',
  '2026-08-28',
  '2026-08-29',
  '2026-08-30',
  '2026-08-31',
  '2026-09-01',
  '2026-09-02',
  '2026-09-03',
  '2026-09-04',
  '2026-09-05',
  '2026-09-06',
  '2026-09-07',
  '2026-09-08',
  '2026-09-09',
  '2026-09-10'
];

export const gfsDates_spfh = [
  '2026-08-25',
  '2026-08-26',
  '2026-08-27',
  '2026-08-28',
  '2026-08-29',
  '2026-08-30',
  '2026-08-31',
  '2026-09-01',
  '2026-09-02',
  '2026-09-03',
  '2026-09-04',
  '2026-09-05',
  '2026-09-06',
  '2026-09-07',
  '2026-09-08',
  '2026-09-09',
  '2026-09-10'
];

export const gfsDates_precip = [
  '2026-08-25',
  '2026-08-26',
  '2026-08-27',
  '2026-08-28',
  '2026-08-29',
  '2026-08-30',
  '2026-08-31',
  '2026-09-01',
  '2026-09-02',
  '2026-09-03',
  '2026-09-04',
  '2026-09-05',
  '2026-09-06',
  '2026-09-07',
  '2026-09-08',
  '2026-09-09',
  '2026-09-10'
];

export const gfsVariableMetadata = {
  sst: {
    label: "Surface Temperature",
    unit: "\u00b0C",
    vmin: 20.0,
    vmax: 32.0,
    cmap: "RdYlBu_r",
  },
  pressure: {
    label: "Pressure",
    unit: "hPa",
    vmin: 990.0,
    vmax: 1025.0,
    cmap: "coolwarm",
  },
  wind: {
    label: "Wind Speed",
    unit: "m/s",
    vmin: 0.0,
    vmax: 20.0,
    cmap: "YlOrRd",
  },
  airtmp: {
    label: "Air Temperature",
    unit: "\u00b0C",
    vmin: 18.0,
    vmax: 34.0,
    cmap: "RdYlBu_r",
  },
  spfh: {
    label: "Specific Humidity",
    unit: "kg/kg",
    vmin: 0.005,
    vmax: 0.025,
    cmap: "BuGn",
  },
  precip: {
    label: "Precipitation",
    unit: "mm/day",
    vmin: 0.0,
    vmax: 30.0,
    cmap: "Blues",
  },
};

export const gfsVariableOrder = ["sst", "pressure", "wind", "airtmp", "spfh", "precip"];

export const gfsRegionMetadata = {
  'palau': {
    label: "Palau EEZ",
    averageCsvTemplate: '/jsonFiles/forecasts/gfs/{var}/palau/timeseries/average.csv',
    locationJsonTemplate: '/jsonFiles/forecasts/gfs/{var}/palau/timeseries/by_location.json',
    overlayUrl: "/CMIPtas/palauEEZ.json",
  },
  'rmi': {
    label: "Marshall Islands EEZ",
    averageCsvTemplate: '/jsonFiles/forecasts/gfs/{var}/rmi/timeseries/average.csv',
    locationJsonTemplate: '/jsonFiles/forecasts/gfs/{var}/rmi/timeseries/by_location.json',
    overlayUrl: "/CMIPtas/rmiEEZ.json",
  },
  'rmi-wake': {
    label: "Marshall Islands EEZ + Wake Island U.S. EEZ",
    averageCsvTemplate: '/jsonFiles/forecasts/gfs/{var}/rmi-wake/timeseries/average.csv',
    locationJsonTemplate: '/jsonFiles/forecasts/gfs/{var}/rmi-wake/timeseries/by_location.json',
    overlayUrl: "/CMIPtas/rmiEEZWithWake.json",
  },
  'indo-pacific': {
    label: "Indo-Pacific",
  },
};
